export const cannotProtectMessageWithCloudAttachment = "Mkb";
export default {cannotProtectMessageWithCloudAttachment};